<template>
  <header :class="['fixed w-full z-50 transition-all duration-500', scrolled ? 'header-solid shadow-xl' : 'header-transparent']">
    <nav class="flex items-center justify-between px-6 md:px-10 py-3">
      <router-link to="/">
        <img src="../assets/logo-branco.png" alt="Prefeitura de Duque de Caxias" width="110" />
      </router-link>

      <div class="hidden md:flex items-center gap-6">
        <a href="https://duquedecaxias.rj.gov.br/" target="_blank" class="nav-link">Prefeitura</a>
        <a href="https://saude.duquedecaxias.rj.gov.br/" target="_blank" class="nav-link">Saúde</a>
        <a href="https://transparencia.duquedecaxias.rj.gov.br/" target="_blank" class="nav-link">Transparência</a>
      </div>

      <!-- Mobile -->
      <button class="md:hidden text-white" @click="open = !open">
        <svg v-if="!open" class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"/>
        </svg>
        <svg v-else class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </nav>

    <!-- Mobile menu -->
    <transition name="slide-menu">
      <div v-if="open" class="md:hidden mobile-menu">
        <a href="https://duquedecaxias.rj.gov.br/" target="_blank" class="mobile-link" @click="open=false">Prefeitura</a>
        <a href="https://saude.duquedecaxias.rj.gov.br/" target="_blank" class="mobile-link" @click="open=false">Saúde</a>
        <a href="https://transparencia.duquedecaxias.rj.gov.br/" target="_blank" class="mobile-link" @click="open=false">Transparência</a>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  data() {
    return { open: false, scrolled: false };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 80;
    },
  },
};
</script>

<style scoped>
.header-transparent { background: transparent; }
.header-solid { background: #195493; border-bottom: 3px solid #E8652D; }

.nav-link {
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  transition: color 0.3s;
}
.nav-link:hover { color: #E8652D; }

.mobile-menu {
  background: rgba(15, 52, 96, 0.97);
  padding: 1rem 2rem 2rem;
}
.mobile-link {
  display: block;
  color: white;
  font-weight: 600;
  padding: 0.8rem 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  transition: padding-left 0.3s, color 0.3s;
}
.mobile-link:hover { padding-left: 1rem; color: #E8652D; }

.slide-menu-enter-active { transition: all 0.3s ease; }
.slide-menu-leave-active { transition: all 0.2s ease; }
.slide-menu-enter-from, .slide-menu-leave-to { opacity: 0; transform: translateY(-10px); }
</style>
